// extracted by mini-css-extract-plugin
module.exports = {"button":"SimpleButton_button__2s8qN","submit":"SimpleButton_submit__qALp3","critical":"SimpleButton_critical__3Nw4u","disabled":"SimpleButton_disabled__2qZ2o"};